import { getGeojson } from './getGeojon';
import { GeojsonInput } from './getGeojsonInput';

export const geojson = {
  getGeojson,
  GeojsonInput
};
